// extracted by mini-css-extract-plugin
module.exports = {"rich-text-editor":"_3tJnEOrE9ousmdnEa0rRh6"};